import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { fetchBoundUsers } from "actions";
import { useDispatch } from "react-redux";

const UserFilter = ({userExtraFiltersState, setUserExtraFiltersState, object_viewed_id, programId}) => {
  const dispatch = useDispatch();

  // No dropdown, so no show state needed

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserExtraFiltersState((prevState) => ({
      ...prevState,
      values: {
        ...(prevState.values || {}),
        [name]: value,
      },
    }));
  };



  const handleClear = () => {
    setUserExtraFiltersState({
      values: {
        user: "",
      },
    });
  };

  const handleSearch = () => {
    dispatch(fetchBoundUsers(programId, { object_viewed_id, ...userExtraFiltersState.values }));
  };


  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col md={8} sm={12}>
            <Form.Group>
              <Form.Label className="label-input">User</Form.Label>
              <Form.Control
                type="text"
                placeholder="Type User"
                name="user"
                value={userExtraFiltersState.values?.user || ""}
                onChange={handleChange}
                className="input-field"
              />
            </Form.Group>
          </Col>
          <Col md={2} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100"
            >
              <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
            </button>
          </Col>
          <Col md={2} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-link text-danger w-100"
            >
              Clear
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UserFilter;
